import _ from 'lodash';
import { ORDER_TYPES } from 'v2/common/constants/index';
import moment from 'moment';
import { automaticSupportedBrokers } from 'v2/common/brokerConfigs/index';
import { oneClickSupportedBrokers } from 'common/brokerConfigs/config';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

export const getDefaultOrderType = (newOrderType, currentUser) => {
  const planActiveTill = _.get(currentUser, 'plan_active_till', null);
  const broker = _.get(currentUser, 'broker', '');

  const { paper: { value: paper } } = ORDER_TYPES;

  const { isInInitialOfferPeriod, isAdmin } = window;
  if (ApplicationDomainUtility.isQubit) return newOrderType;

  if (!broker) return paper; // normal mail users... mandatory paper

  // this is not a good practice
  if (isAdmin || isInInitialOfferPeriod || ApplicationDomainUtility.isAlgoverse) return newOrderType;

  if (((_.includes(automaticSupportedBrokers, broker))
    || _.includes(oneClickSupportedBrokers, broker))
    && (planActiveTill && moment().isBefore(planActiveTill))
  ) {
    return newOrderType;
  }

  return paper;
};
